const initialState = {
  pending: null,
  recorderId: null,
  analogParams: [],
  binaryParams: [],
  chosenAnalogParams: [],
  chosenBinaryParams: []
};

export default function recorderCyclo(state = initialState, action) {
  switch (action.type) {
    case 'GET_RECORDER_CYCLO_START':
      return { ...state, ...{ pending: true }};
    case 'GET_RECORDER_CYCLO_COMPLETE':
      return { ...state,
        ...{
          pending: false,
          recorderId: action.payload.response.recorderId,
          analogParams: action.payload.response.analogParams,
          binaryParams: action.payload.response.binaryParams,
        }
      };
    case 'CHANGE_TRACK_PARAM_CHECKSTATE':
      let getIndexById = function (id, array) {
        let itemIndex = null;
        array.forEach((item, index) => {
          if (item.id === id) itemIndex = index;
        });

        return itemIndex; // or undefined
      }

      let chosenParams = [];
      if (action.payload.type === 'ap') {
        chosenParams = state.chosenAnalogParams;
      } else if (action.payload.type === 'bp') {
        chosenParams = state.chosenBinaryParams;
      }

      let itemIndex = getIndexById (
        action.payload.id,
        chosenParams
      );

      if ((action.payload.state === false)
        && (itemIndex !== null)
      ) {
        chosenParams.splice(itemIndex, 1);
      }

      if ((action.payload.state === true)
        && (itemIndex === null)
      ) {
        chosenParams.push({
          id: action.payload.id,
          type: action.payload.type
        });
      }

      return { ...state };
    case 'SET_CHECKED_TRACK_PARAMS':
      return {
        ...state,
        ...{
          chosenAnalogParams: action.payload.ap,
          chosenBinaryParams: action.payload.bp
        }
      };
    default:
      return state;
  }
}
